import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";

interface FavouriteIconProps {
  isFavourite: boolean;
}

export default function FavouriteIcon({ isFavourite }: FavouriteIconProps) {
  return (
    <FontAwesomeIcon
      icon={isFavourite ? faHeartSolid : faHeartRegular}
      color={isFavourite ? "#DC6666" : "#a8a29e"}
    />
  );
}
